import config from '../config/config'
import axios from 'axios'

export function getBackendUserUrl() {
    return config.backendUserUrl
}

export function isNullOrUndefined(value) {
    if (value === null || value === undefined) {
        return true
    }
    return false
}

export function getAddonPrice(addon) {
    // If there are no package options for the addon, get the price from the addon itself.
    let returnValue = 0

    if (
        isNullOrUndefined(addon.company) ||
        isNullOrUndefined(addon.company?.packageInfo) ||
        isNullOrUndefined(addon.packageId) ||
        addon.addonType === 'VenueSpace'
    ) {
        returnValue = addon.price ?? 0
    } else if (
        addon.company &&
        addon.company.packageInfo &&
        addon.company.packageInfo.options
    ) {
        // If there are package options for the addon, check against the existing package options.
        addon.company.packageInfo.options.forEach((packageOption) => {
            if (packageOption.id === addon.packageId) {
                const costPerPerson = packageOption.cost
                returnValue = costPerPerson.substring(
                    costPerPerson.indexOf('$') + 1,
                    costPerPerson.indexOf(' ')
                )
            }
        })
    }
    return returnValue
}

export function getSponsorPrice(sponsor) {
    // Likely will need to be changed later, since
    // currently we are lacking any sponsor information.
    let returnValue = 0
    if (isNullOrUndefined(sponsor)) {
        returnValue = 0
    } else {
        returnValue = sponsor.price
    }
    return returnValue
}

export function getTestAccounts() {
    return config.testAccounts
}

export function getGoogleClientId() {
    // console.log(config.GOOGLE_CLIENT_ID)
    // console.log(process.env.REACT_APP_GOOGLE_CLIENTID_LOGIN)
    return config.GOOGLE_CLIENT_ID
}

export function getApiUrl() {
    return config.API_URL
}

export function getMailjetKeys() {
    return {
        public: config.MJ_APIKEY_PUBLIC,
        private: config.MJ_APIKEY_PRIVATE,
    }
}

export function haversine(lat1, lon1, lat2, lon2) {
    const R = 3956 // Radius of the Earth in miles

    const dlat = (lat2 - lat1) * (Math.PI / 180) // Convert degrees to radians
    const dlon = (lon2 - lon1) * (Math.PI / 180) // Convert degrees to radians

    const a =
        Math.sin(dlat / 2) ** 2 +
        Math.cos(lat1 * (Math.PI / 180)) *
            Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dlon / 2) ** 2
    const c = 2 * Math.asin(Math.sqrt(a))

    return R * c // Distance in miles
}

export async function fetchGeocodeData(address, apiKey) {
    const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}`
    )
    const data = await response.json()
    if (data.status === 'OK') {
        const { lat, lng } = data.results[0].geometry.location
        return [lat, lng]
    } else {
        console.error(
            'Geocode was not successful for the following reason:',
            data.status
        )
    }
}

export async function getCurrentUser() {
    const token = localStorage.getItem('authToken')
    if (token) {
        try {
            // If decoding succeeds, verify with the backend
            const apiUrl = getBackendUserUrl() + '/user/get_current_user'

            const response = await axios.get(apiUrl, {
                headers: { Authorization: `Bearer ${token}` },
            })
            return response.data
        } catch (error) {
            console.error('Error fetching user data:', error)
            localStorage.removeItem('authToken')
            return null
        }
    } else {
        return null
    }
}
